import React, { Component, lazy, Suspense } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import LazyLoad from "react-lazyload";
import carf from "./static/icons/carrefour.svg";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Pages404 from './pages/pages-404';
import bg1 from "./static/carrefourbg1.jpg";
import bg2 from "./static/carrefourbg2.jpg";
import bg3 from "./static/carrefourbg3.jpg";
// const Home = lazy(() => import("./pages/Home"));
const Home = lazy(() => import("./pages/Home"));

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { bg: bg2 };
  }

  componentDidMount() {
    const rd = Math.floor(Math.random() * 2);
 
 this.setState({
   bg: rd === 0 ? bg1 : rd === 1 ? bg2 : bg3,
 });
 
  }
  render() {
   

    return (
      <HelmetProvider>
        <Router>
          <div>
            <LazyLoad height={200} once>
              <div
                style={{
                  backgroundColor: " rgb(255 247 255 / 70%)",
                  padding: "10px",
                }}
              >
                <img src={carf} style={{width:"97px",height:"120px"}} className="logo-carrefour" alt="carrefour" />
                <Helmet>
                  <style>{`body {background-image: url(${this.state.bg}); }`}</style>
                </Helmet>
              </div>
            </LazyLoad>
            <Suspense fallback={<div className="loadingspinner"> </div>}>
              <Switch>
                <Route exact path="/404" component={Pages404} />
                <Route path="/" component={Home} />
              </Switch>
            </Suspense>
          </div>
        </Router>
      </HelmetProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js